/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_SegmentationInputs */



/**
* | output |
* | --- |
* | "Segmentation" |
*
* @param {Ad_Section_SegmentationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_segmentation = /** @type {((inputs?: Ad_Section_SegmentationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_SegmentationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segmentation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segmentazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сегментация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Segmentación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("片段选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("区間指定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Segmentação")
	return /** @type {LocalizedString} */ ("Segmentation")
});